import type { QueryClient } from "@tanstack/react-query";
import type { TFunction } from "i18next";
import { toast } from "sonner";
import { ApiError } from "@/lib/api-client";
import { promptsKeys } from "@/lib/queries";

export function isStalePromptVersion(err: unknown): boolean {
  return err instanceof ApiError && (err.status === 409 || err.code === "CONFLICT");
}

function reloadPrompt(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: promptsKeys.all });
}

/** A 409 reloads the prompt. Other failures keep the generic save or revert toast. */
export function notifyPromptVersionError(
  err: unknown,
  t: TFunction,
  queryClient: QueryClient,
  kind: "save" | "revert",
): void {
  if (isStalePromptVersion(err)) {
    reloadPrompt(queryClient);
    toast.error(
      t(
        "prompts.editor.toast.versionStale",
        "This prompt changed elsewhere. Review the latest version, then save again.",
      ),
      {
        action: {
          label: t("prompts.editor.toast.reload", "Reload"),
          onClick: () => reloadPrompt(queryClient),
        },
      },
    );
    return;
  }
  toast.error(
    kind === "save"
      ? t("prompts.editor.toast.versionFailed", "Failed to save version")
      : t("prompts.editor.toast.revertFailed", "Failed to revert"),
  );
}
